export default __webpack_public_path__ + "46daafe.png";